import React, { useState } from 'react'

function MEAN_Stack_Full_Stack_Developers_Course() {

    const [toggle, setTg] = useState();

    return (
        
        <div>
            

            <div className="banner-ai">
    <div className="container position-relative">
        <div className="banner-ai-inner">
        <div className="banner-ai-links">
            <ul>
                <li><a href="">Home</a></li>
                <li><a href="">Full Stack Developer Course</a></li>
                <li><a href="">MEAN Stack Full Stack Developers Course</a></li>
            </ul>
        </div>
        <div className="bestsaller">
            <span><i className="fa fa-star" aria-hidden="true"></i> Bestseller</span>
            <div className='ratinglink'>5 
            <div className='ratingstarfa'>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            </div>
            <a href="#ratingreviews">(819 Ratings)</a></div>
        </div>
        <div className="banner-ai-text">
            <h1>MEAN Stack Full Stack Developers Course</h1>
            <p>Gain expertise in MEAN Stack Full Stack Developers Course from leading professionals worldwide and obtain a MEAN Stack Full Stack Developers Course Certification from prestigious universities around the world. Develop into a skilled Data Scientist 
                by enrolling in our comprehensive MEAN Stack Full Stack Developers Course courses tailored for both working professionals and recent graduates.</p>
        </div>
        <div className="banner-ai-btngrp">
            <a href="" className="applybtn">Apply Now</a>
            <a href="" className="downbtn"><i className="fa fa-download" aria-hidden="true"></i> Download Syllabus</a>
            <div className="watchbanner">
                <div className="rippleinfo" data-toggle="modal" data-target="#introvideo">                
                    <span><i className="fa fa-play videoicons" aria-hidden="true"></i></span>
                  </div>
                  <h6>Watch <br/><label>INTRO VIDEO</label></h6>
                </div>
        </div>
        <div className="banner-ai-experts">
            <p>Ranked #1 MEAN Stack Full Stack Developers Course Training With Industry Experts From</p>
            <a href=""><img alt="" src="assets/images/gramener.png" /></a>
            <a href=""><img alt="" src="assets/images/actify.png" /></a>
            <a href=""><img src="assets/images/flipcart.png" alt="" /></a>
            <a href=""><img src="assets/images/walmart.png" alt="" /></a>
            <a href=""><img alt="" src="assets/images/zee.png" /></a>
        </div>
    </div>
    </div>
</div>


<div className="banner-aistrip">
    <div className="container">
        <ul>
            <li>
                <span><img src="assets/images/banner-aistrip-icon1.png" alt="" /></span>
                <div className="banner-aistrip-text">
                     <h5>120% Average Hike</h5>
                     <p>in Job Switch</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon2.png" alt="" /></span>
                <div className="banner-aistrip-text">
                     <h5>8 Months</h5>
                     <p>Weekend Live Classes</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon3.png" alt="" /></span>
                <div className="banner-aistrip-text">
                     <h5>Project Based Learning</h5>
                     <p>Real Time Projects</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon4.png" alt="" /></span>
                <div className="banner-aistrip-text">
                     <h5>Job Assistance</h5>
                     <p>100% Placements</p>
                </div>
            </li>
            <li>
                <span><img src="assets/images/banner-aistrip-icon5.png" alt="" /></span>
                <div className="banner-aistrip-text">
                     <h5>Starts at INR 6,736/month*</h5>
                     <p>EMI Options Available</p>
                </div>
            </li>
        </ul>
    </div>
</div>

<div className="faqnewbg">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course Course Overview</h1>
        <p>Our MEAN Stack Full Stack Developers Course course, in partnership with startUp MEAN Stack Full Stack Developers Course certification, is led by experienced instructors who will guide you in mastering the field of MEAN Stack Full Stack Developers Course. The comprehensive training program covers various topics such as Python programming, Machine Learning, and real-time projects, ensuring you gain practical knowledge and skills.</p>
        <div className="faqnewbg-inner">
             

                
                    <div className="faqnew">
                    <div className="accordion" id="accordionExample2">

                        <div className="card">
                        
                            <div className="card-header" id="heading00">
                        
                              <h2 className="mb-0">
                        
                                <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i className="fa fa-angle-down"></i> Introduction to MEAN Stack Full Stack Developers Course Courses </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse00" className="collapse" aria-labelledby="heading00" data-parent="#accordionExample2">
                        
                              <div className="card-body">
                               <p>The most comprehensive MEAN Stack Full Stack Developers Course course on the market is offered by Logicmojo. The course covers every step of the Data Analytics lifecycle, including data collection, extraction, cleaning, exploration, transformation, feature engineering, integration, and mining as well as the creation of prediction models, data visualisation, and client deployment. Statistical analysis, text mining, regression modelling, hypothesis testing, predictive analytics, machine learning, deep learning, neural networks, natural language processing, predictive modelling, and programming languages like R and Python are just a few of the skills and tools that are taught in the training.</p>
                                 <p>The Logicmojo MEAN Stack Full Stack Developers Course course is intended for both people with no prior experience in the area who wish to acquire the fundamental ideas and techniques as well as those who wish to advance their knowledge and abilities. The course offers both in-person and online teaching, with knowledgeable professors who offer individualised feedback and assistance.</p>
                                <p>This education in Data Analytics is intended to educate students for professions in Data Analytics, and Logicmojo is known as the best Data Analytics training facility that provides all-inclusive services from training to placement. As part of the MEAN Stack Full Stack Developers Course training programme, over 900 learners were successfully placed at prestigious multinational corporations including Microsoft, Flipkart, WalmartLabs, VMWare, Uber, and IBM, among others. The best MEAN Stack Full Stack Developers Course training is offered by Logicmojo, which is regarded as the leading institution in the field.</p>
                                 <p>The Logicmojo course's curriculum is designed around actual projects and issues, giving students the chance to put their knowledge and skills to use in real-world situations. In order to reinforce learning and track progress, the course also contains interactive quizzes and exercises.</p>
                                 <br/> <img  src="assets/images/mac/what-is-data-science.jpeg" style={{ width: "90%"}} alt="" /><br/><br/>
                                <p>The Logicmojo course provides specialised modules in fields including machine learning, deep learning, and big data in addition to the main curriculum. These courses are made for those who want to specialise in a particular field of Data Analytics or work in academia or research.</p>
                                 <p>For anyone looking to get the skills and information necessary to be successful in the field of Data Analytics, the Logicmojo Data Analytics course is a thorough and effective course. All students will benefit from the course's unique and satisfying learning experience thanks to its practical approach and qualified instructors.</p>
                                 </div>
                        
                            </div>
                        
                        </div>

                        <div className="card">
                        
                            <div className="card-header" id="heading01">
                        
                              <h2 className="mb-0">
                        
                                <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse01" aria-expanded="false"><i className="fa fa-angle-down"></i> About the MEAN Stack Full Stack Developers Course course developed in collaboration with IBM </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse01" className="collapse" aria-labelledby="heading01" data-parent="#accordionExample2">
                        
                              <div className="card-body">
                              <p>Logicmojo and IBM have joined forces to offer an integrated blended learning experience for individuals interested in MEAN Stack Full Stack Developers Course. The course, which is completed in partnership with IBM, presents an opportunity for career progression and skills acquisition necessary to thrive in the field. The program offers comprehensive training on highly sought-after skills in MEAN Stack Full Stack Developers Course and Machine Learning, with practical experience using essential tools and technologies such as Python, R, Tableau, and the principles of Machine Learning. The course is designed to explore the intricacies of data interpretation, master cutting-edge technologies such as Machine Learning, and develop strong programming skills to equip you to soar high in the field of MEAN Stack Full Stack Developers Course.</p>
                              <p>The integrated blended learning approach in the MEAN Stack Full Stack Developers Course course, done in partnership with IBM, aims to equip students with the skills required to become proficient in Data Analytics. By taking this course, individuals can prepare themselves for prominent data scientist job positions in the industry. The course's blended learning approach combines online self-paced modules and in-person instructor-led classes to enable students to learn at their own pace and receive personalized feedback and support from experienced instructors.</p>
                              <p>The MEAN Stack Full Stack Developers Course course developed in partnership with IBM presents a plethora of advantages, including its industry-oriented approach. Industry experts design the curriculum, ensuring its relevance to the industry's needs. The course also includes real-world projects and case studies that provide individuals with the opportunity to apply their skills and knowledge to practical scenarios. Additionally, the course boasts experienced instructors with extensive experience in the field of Data Analytics, providing students with valuable insights and guidance.</p>
                              <br/> <img  src="assets/images/mac/IBM-Cert.jpeg" style={{ width: "80%"}} alt="" /><br/><br/>
                              <p>Upon completion of the course, individuals receive a certification from IBM, a testament to their expertise in the field of MEAN Stack Full Stack Developers Course. This certification represents a significant step towards professional growth and advancement in the field.</p>
                              
                                </div>
                        
                            </div>
                        
                        </div>

                        <div className="card">
                        
                            <div className="card-header" id="heading020">
                        
                              <h2 className="mb-0">
                        
                                <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse020" aria-expanded="false"><i className="fa fa-angle-down"></i> What can I expect from this MEAN Stack Full Stack Developers Course course developed for working professionals ? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse020" className="collapse" aria-labelledby="heading020" data-parent="#accordionExample2">
                        
                              <div className="card-body">
                        
                                <p>Working professionals are looking for a career shift in the field of Data Analytics. MEAN Stack Full Stack Developers Course has been dubbed the highest-paying job of the 21st century</p>
                                <ul>
                                    <li>Flexibility: Logicmojo course designed for working professionals is typically offered online and can be accessed at any time, making it easy to fit into a busy schedule.</li>
                                    <li>Real-world applications: Logicmojo course focus on practical applications of MEAN Stack Full Stack Developers Course concepts and techniques, allowing you to apply what you learn to your job immediately.</li>
                                    <br/> <img  src="assets/images/mac/Best-Choice.png" style={{ width: "80%"}} alt="" /><br/><br/>
                                    <li>Hands-on experience: You can expect to work on real data sets and projects, gaining hands-on experience and building a portfolio of work that you can showcase to potential employers.</li>
                                    <li>Experienced instructors: Logicmojo course taught by experienced MEAN Stack Full Stack Developers Course professionals who can provide guidance and mentorship throughout the program</li>
                                    <li>Networking opportunities: Logicmojo will provide opportunities to connect with other professionals in the field of MEAN Stack Full Stack Developers Course, allowing you to build your professional network and learn from others' experiences.</li>
                                    <li>Certification: Upon completing the Live course, you should receive a certification that demonstrates your proficiency in MEAN Stack Full Stack Developers Course, which can help you advance your career.</li>
                                </ul>
                              </div>
                        
                            </div>
                        
                        </div>


                        <div className="card">
                        
                            <div className="card-header" id="heading02">
                        
                              <h2 className="mb-0">
                        
                                <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse02" aria-expanded="false"><i className="fa fa-angle-down"></i> Why should I enroll in this MEAN Stack Full Stack Developers Course certification course </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse02" className="collapse" aria-labelledby="heading02" data-parent="#accordionExample2">
                        
                              <div className="card-body">
                                <p>The need for qualified data scientists is growing as firms depend more on data-driven solutions. You will acquire the necessary skills for MEAN Stack Full Stack Developers Course, Python programming, Statistics, Data Analysis, and Big Data through the Logicmojo online training programme. Having this qualification will help you advance your career in this quickly expanding industry.</p>
                                <ul>
                                    <li>The US Bureau of Labour Statistics projects that employment in the field of Data Analytics will increase by 31% between 2019 and 2029, which is substantially faster than the average for all occupations. The top career for the 21st century is data scientist, according to Harvard Business Review</li>
                                    <li>The top career for the 21st century is data scientist, according to Harvard Business Review</li>
                                    <li>There will be 3.4 million more employment for data experts in India, according to IBM.</li>
                                    <li>According to IBM, there will be 3.7 million jobs for all data professionals in the US by 2023, a huge rise from the 700,000 jobs there were in 2015.</li>
                               <li>According to a Kaggle poll, Data Scientists with a Master's degree make $16,000 more a year on average than those without one. This emphasises even more the potential advantages of taking a MEAN Stack Full Stack Developers Course course.</li>
                                </ul>
                                <br/> <img  src="assets/images/mac/Logicmojo-Best.jpeg" style={{ width: "90%"}} alt="" /><br/><br/>
                             <p>Data Analytics specialists are highly sought after across sectors. If you're thinking about working in this industry, taking a certification course can help you acquire the skills and information you'll need to stand out on the job market. We'll look at the benefits of taking a Data Analytics certification course in this article.</p>
                              <ul>
                              <li>
                                <p>Obtain Needed Skills</p>
                             <p>Taking a Data Analytics certification course will give you the knowledge and resources you need to manage, analyse, and visualise data. You'll study statistical methodologies, machine learning principles, and programming languages like Python and R. From healthcare to finance, these abilities are highly sought after and can help you land a fulfilling job with a good wage.</p>
                              </li>

                              <li>
                                <p>Stay Ahead of the Curve</p>
                              <p>The subject of Data Analytics is fast growing, and new tools and methods are constantly being developed. You can keep up with the most recent technological developments in the field by taking a certification course. You'll receive instruction from seasoned professors who are familiar with the most recent trends and recommended procedures. You'll be in a better position to seize fresh chances as they present themselves if you stay one step ahead of the curve.</p>
                              </li>

                              <li>
                                <p> Validate Your Expertise</p>
                             <p>A Data Analytics certification is a practical approach to demonstrate your subject-matter knowledge. It shows prospective employers that you possess the abilities and knowledge required to succeed in the position. Additionally, it can set you apart from other applicants who might lack a credential. Employers will know that you're serious about a career in Data Analytics if you obtain a certification.</p>
                              </li>

                              <li>
                                <p> Build a Professional Network</p>
                              <p>A certification programme is a great method to connect with other professionals in the Data Analytics industry. You'll get the chance to speak with other experts in the subject, including teachers and other students. Through this, you could make useful connections that boost your career. Additionally, you can have access to job advertisements and other tools that can aid in your job search.</p>
                              </li>

                              <li>
                                <p> Flexible Learning Options</p>
                             <p>Numerous Data Analytics certification programmes include flexible learning choices, such as online programmes that can be finished at your own time. If you already work or have other obligations that make it impossible for you to attend traditional in-person classes, this may be extremely helpful. You may learn from any location, at any time, and at a pace that suits you with online classes.</p>
                              </li>


                              </ul>
                              </div>
                        
                            </div>
                        
                        </div>


                        <div className="card">
                        
                            <div className="card-header" id="heading030">
                        
                              <h2 className="mb-0">
                        
                                <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse030" aria-expanded="false"><i className="fa fa-angle-down"></i> What will you learn in this best MEAN Stack Full Stack Developers Course course? </button>
                        
                              </h2>
                        
                            </div>
                        
                            <div id="collapse030" className="collapse" aria-labelledby="heading030" data-parent="#accordionExample2">
                        
                              <div className="card-body">
                                
                              <p>You will receive certifications from Logicmojo and IBM for all of the courses in the learning route after completing this MEAN Stack Full Stack Developers Course course. These credentials will serve as proof of your knowledge and competence in Data Analytics. You can also profit from the following advantages that are provided as part of this course.</p><br/>
                                <ul>
                                    <li>The fundamentals of Python, Statistics, and Probability are covered in this course, along with more advanced material on Machine Learning, MEAN Stack Full Stack Developers Course, Deep Learning, Neural Networks, and Computer Vision. The programme gives you a thorough understanding of the discipline by covering a wide range of topics at beginner to expert levels. You will be prepared to take on the role of a Data Scientist after finishing this course. Additionally, there are prospects for job placement after the programme is successfully completed.</li><br/>
                                    
                                    <li>After completing the Logicmojo Data Analytics courses, you will be awarded an IBM certification. This accreditation attests to the fact that you finished the programme successfully. It proves to prospective employers that you are knowledgeable in the field of Data Analytics. Your professional credentials will benefit from the IBM certification, which might also increase your employment prospects. The Logicmojo course can lead to intriguing work opportunities in the Data Analytics industry, and the IBM certification can help you get there.</li><br/>

                                    <br/> <img  src="assets/images/mac/Why-Choose-DataSciecne.jpg" style={{ width: "90%"}} alt="" /><br/><br/>
                                    <li>Doubt sessions are held during the workweek to help you with any Data Analytics concerns you may have. You have the chance to get any questions or concerns you might have about the course material answered during these meetings. The goal of the doubt sessions is to guarantee your comprehension of and advancement in the discipline of Data Analytics.</li><br/>

                                  <li>After finishing, you will be sent to reputable goods companies. You might be able to get employment chances with these companies thanks to this reference.</li>

                                </ul>
                        
                              </div>
                        
                            </div>
                        
                        </div>

                        
                        </div>
                    </div>
                

             

        </div>
    </div>
</div>
<div className="itfeaturevideorow">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course is the Future of IT</h1>
        <div className="itfeaturevideo">
        <iframe loading="lazy" src="https://www.youtube.com/embed/F9Lf-mejfdA" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" width="100%" height="450" frameborder="0"></iframe>
        </div>
    </div>
</div>


<div className="careeroppbg">
    <div className="container">
        <div className="careeroppbg-inner">
            <h1>What roles does a Data Scientist Play?</h1>

         
  <ul className="nav nav-tabs" role="tablist">
    <li className="nav-item">
      <a className="nav-link" data-toggle="tab" href="#tab01"><span><img src="assets/images/opportunities-icon1.png" alt="" /></span>Machine Learning Engineer</a>
    </li>
    <li className="nav-item">
      <a className="nav-link active" data-toggle="tab" href="#tab02"><span><img src="assets/images/opportunities-icon2.png" alt="" /></span>Data Scientist</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" data-toggle="tab" href="#tab03"><span><img src="assets/images/opportunities-icon3.png" alt="" /></span>Software Engineer</a>
    </li>
    <li className="nav-item">
        <a className="nav-link" data-toggle="tab" href="#tab04"><span><img src="assets/images/opportunities-icon4.png" alt="" /></span>Data Analytics</a>
      </li>
  </ul>

  <div className="tab-content">
    <div id="tab01" className="tab-pane">
      <div className="careeroppbg-inner-text">
        <p>According to job market data, the demand for machine learning engineers has increased by over 344% since 2015.As machine learning technologies continue to evolve and become more sophisticated, the demand for skilled engineers who can design, develop, and implement machine learning systems will only continue to grow. This is especially true in industries such as healthcare, finance, and e-commerce, where machine learning is being used to develop predictive models, detect fraud, and personalize user experiences.</p>
        <h3>Average Salaries</h3>
        <h3>Rs. 2400K - Rs. 6000K <span>Per annum</span></h3>
        <h4>Hiring Compenies</h4>
        <a href=""><img src="assets/images/microsofticon.png" alt="" /></a>
        <a href=""><img src="assets/images/walmarticon.png" alt="" /></a>
        <a href=""><img src="assets/images/googleicon.png" alt="" /></a>
        <a href=""><img src="assets/images/amazonicon.png" alt="" /></a>
        <a href=""><img src="assets/images/flipcarticon.png" alt="" /></a>
      </div>
    </div>
    <div id="tab02" className="tab-pane fade active show">
        <div className="careeroppbg-inner-text">
            <p>The demand for data scientists has been increasing rapidly in recent years, and it is expected to continue to grow in the future. According to job market data, the demand for data scientists has increased by over 650% since 2018.data scientists are expected to be highly skilled professionals who are able to use data to drive business insights and decisions. They should have a combination of technical, analytical, and communication skills, and be able to apply these in a business context to deliver value to their organization</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 2000K - Rs. 8000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href=""><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href=""><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href=""><img src="assets/images/googleicon.png" alt="" /></a>
            <a href=""><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href=""><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
    </div>
    <div id="tab03" className="tab-pane fade">
        <div className="careeroppbg-inner-text">
            <p>Software engineer also work as statistics, machine learning, and data visualization in addition to programming skills.</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href=""><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href=""><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href=""><img src="assets/images/googleicon.png" alt="" /></a>
            <a href=""><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href=""><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
    </div>
    <div id="tab04" className="tab-pane fade">
        <div className="careeroppbg-inner-text">
            <p>Data analytics professionals are skilled in collecting, organizing, and analyzing data to extract meaningful insights and identify patterns and trends. They use a variety of tools and techniques to extract insights from large and complex datasets, including statistical analysis, data visualization, and machine learning.One of the main drivers of demand for data analytics professionals is the explosion of digital data in recent years. With the increasing digitization of business operations, there is a huge demand for professionals who can make sense of this data and help businesses make informed decisions.</p>
            <h3>Average Salaries</h3>
            <h3>Rs. 400K - Rs. 2000K <span>Per annum</span></h3>
            <h4>Hiring Compenies</h4>
            <a href=""><img src="assets/images/microsofticon.png" alt="" /></a>
            <a href=""><img src="assets/images/walmarticon.png" alt="" /></a>
            <a href=""><img src="assets/images/googleicon.png" alt="" /></a>
            <a href=""><img src="assets/images/amazonicon.png" alt="" /></a>
            <a href=""><img src="assets/images/flipcarticon.png" alt="" /></a>
          </div>
      </div>
  </div>

        </div>
    </div>
</div>


<div className="getcertfiedbgnew">
    <div className="container">
        <div className="getcertfiedbgnew-inner">
            <h1>MEAN Stack Full Stack Developers Course Course Key Highlights</h1>
            <h6>Master the skills of MEAN Stack Full Stack Developers Course and AI with hands-on experience through real-world projects, and transition into a role as a Data Scientist or AI-ML professional</h6>
            <div className="row">
                <div className="col-md-4">
                    <div className="getcertfiedbgnew-box">
                        <i className="fa fa-laptop" aria-hidden="true"></i>
                        <h2>100% Live Online Classes</h2>
                        <p>Faculty led Live Interactive online classes on weekend &amp; Live doubt sessions on Weekdays</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="getcertfiedbgnew-box">
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        <h2>Build Work Experience</h2>
                        <p>Don't just Learn, Apply your learnings - work with companies project.Real-world experience by working on live projects</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="getcertfiedbgnew-box">
                        <i className="fa fa-briefcase" aria-hidden="true"></i>
                        <h2>Land your Dream Job</h2>
                        <p>Secure a guaranteed job referral to leading companies and startups, and kickstart your career in Data Analytics, AI &amp; Machine Learning.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div className="ourclientbg-new">
    <div className="container">
        <h1>Our Alumni Works at</h1>
        <div className="owl-carousel owl-theme">
            <div className="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
                <img src="assets/images/microsofticon.png" alt="" />
                <img src="assets/images/walmarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
                <img src="assets/images/amazonicon.png" alt="" />
                <img src="assets/images/flipcarticon.png" alt="" />
                <img src="assets/images/googleicon.png" alt="" />
            </div>
        </div>
    </div>
</div>



<div className="whymakesnew">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course Course Features</h1>
        <div className="row">
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/whymake-icon1.png" alt="" />
                    <h4>1-on-1 Dedication</h4>
                    <p>Experience personalized learning and growth with live interactive sessions led by industry experts</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/whymake-icon2.png" alt="" />
                    <h4> Practical Experience through Real-Time Projects</h4>
                    <p>Gain invaluable real-world experience by working on live projects. Switch your domain to MEAN Stack Full Stack Developers Course &amp; AI with real time projects.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/whymake-icon3.png" alt="" />
                    <h4>Life Time Access </h4>
                    <p>Life Time accessibility of the Content. Get Access of all Recording of All Classes for Download in Slack Channel.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/studyassigment.png" alt="" />
                    <h4>60+ Case Studies &amp; Assignments</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/industries.png" alt="" />
                    <h4>18+ Industry Relevant Projects</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="whymakes-box">
                    <img src="assets/images/whymake-icon3.png" alt="" />
                    <h4>Tied-up with 150+ Companies</h4>
                    <p>Work on 60+ Case studies ad assignments with 24/7 Assignments suport.</p>
                </div>
            </div>
        </div>
    </div>
</div>






<div className="specialisation-bg">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course Specialisation Program</h1>
        <h5>Below topics and skills can you expect to acquire during an 8-month Data Analytics course</h5>

                
  <ul className="nav nav-tabs" role="tablist">
    <li className="nav-item">
      <a className="nav-link active" data-toggle="tab" href="#tab06">Python & Applied Statistics</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" data-toggle="tab" href="#tab07">Machine Learning</a>
    </li>
    <li className="nav-item">
      <a className="nav-link" data-toggle="tab" href="#tab08">Deep Learning TensorFlow</a>
    </li>
    <li className="nav-item">
        <a className="nav-link" data-toggle="tab" href="#tab09">Tableau & Power BI</a>
      </li>
      <li className="nav-item">
        <a className="nav-link" data-toggle="tab" href="#tab010">NLP</a>
      </li>
  </ul>

  
  <div className="tab-content">
    <div id="tab06" className="tab-pane active">
        <div className="topic_covered">
            <h2>Topics Covered</h2>
            <div className="row">
                <div className="col-md-6">
                    <div className="coveredrow">
                        <div className="coveredrow-left"><span>1</span></div>
                        <div className="coveredrow-right">
                            <h3>Object-oriented programming <br/>&amp; in Python</h3>
                            <ul>
                                <li>OOP Terminology (classes, objects, inheritance, polymorphism, encapsulation)</li>
                                <li>constructors and destructors, static methods, overriding</li>
                                <li>super() to call parent methods</li>
                                </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                        <div className="coveredrow-left"><span>2</span></div>
                        <div className="coveredrow-right">
                            <h3>Functional programming in Python</h3>
                            <li>Built-in functions for iterables(map, filter, reduce, etc.)</li>
                            <li>Lambda functions,Closures, Function decorators</li>
                            <li>itertools, functools, operator module etc</li>
                            <li>Exceptional Handling and Regular Expression</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                        <div className="coveredrow-left"><span>3</span></div>
                        <div className="coveredrow-right">
                            <h3>Python Data Structures <br/>&amp; Sets, Dictionaries, Namedtuples etc</h3>
                           <li>Basic Operations Indexing, Slicing, and Matrixes</li>
                           <li>List, Tuples, Dictionaries  Python Lists, Tuples, Dictionaries</li>
                           <li>Exercises on List, Tuples And Dictionary</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                        <div className="coveredrow-left"><span>4</span></div>
                        <div className="coveredrow-right">
                            <h3>NumPy, Pandas <br/>&amp; Matplotlib, Scikit-learn</h3>
                            <li>Introduction Numpy, Pandas, Matplotlib, Seaborn, Scipy</li>
                            <li>Setting up the development environment</li>
                            <li>NumPy arrays and Data Types</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                        <div className="coveredrow-left"><span>5</span></div>
                        <div className="coveredrow-right">
                            <h3>TensorFlow, Data Preprocessing <br/>&amp; Data visualization</h3>
                            <li>Installing TensorFlow and setting up the development env</li>
                            <li>Data cleaning and transformation</li>
                            <li>Creating subplots and multiple plots</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                        <div className="coveredrow-left"><span>6</span></div>
                        <div className="coveredrow-right">
                            <h3> Data Visualization using Matplotlib</h3>
                           <li>Matplotlib and setting up the development env</li>
                           <li>Advanced Plots with Matplotlib</li>
                           <li>Advanced Visualizations: histograms, heatmaps and box</li>
                           <li>Advanced customization with OOI</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                        <div className="coveredrow-left"><span>7</span></div>
                        <div className="coveredrow-right">
                            <h3>Data Analysis Using Pandas</h3>
                            <li>Data structures in Pandas: Series and DataFrames</li>
                            <li>Basic data exploration with Pandas</li>
                            <li>Statistical Analysis &amp; Data visualization with Pandas</li>
                            <li>Reshaping Data &amp; Hierarchical indexing in Pandas</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                        <div className="coveredrow-left"><span>8</span></div>
                        <div className="coveredrow-right">
                            <h3>Fundamentals of Math and Probability</h3>
                            <li>Population, Sample, Mean, Population Distribution</li>
                            <li>Sample Distribution,Mean, Median, Mode</li>
                            <li>Range, Measure of Dispersion, Variance</li>
                            <li>Probability Density function</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                        <div className="coveredrow-left"><span>9</span></div>
                        <div className="coveredrow-right">
                            <h3>Standard, Normal Distribution, Gaussian Distribution</h3>
                            <li>Standard Normal Distribution, Z Score</li>
                            <li>Cumulative  Distribution function</li>
                            <li>Pearson Correlation Coefficient</li>
                            <li>Spearman Rank Coefficient, Hypothesis Testing</li>

                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                        <div className="coveredrow-left"><span>10</span></div>
                        <div className="coveredrow-right">
                            <h3>Q-Q plot, Bernoulli &amp; Binomial Distribution</h3>
                            <li>Q-Q plot, Skewness of Data</li>
                            <li>Discrete, Bernoulli & Continuous Distribution</li>
                            <li>Log normal, Poisson & Pox cox transformation</li>
                            <li>Application of Non Gaussian distribution</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox11">
                        <div className="coveredrow-left"><span>11</span></div>
                        <div className="coveredrow-right">
                            <h3>Poisson Distribution &amp; Advanced Statistics</h3>
                            <li>Probability Mass Function and Cumulative Distribution</li>
                            <li>Poisson Approximation to the Binomial Distribution</li>
                            <li>Hypothesis Testing and Statistical Inference</li>
                            <li>Case Study Based on Poisson Distribution</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox12">
                        <div className="coveredrow-left"><span>12</span></div>
                        <div className="coveredrow-right">
                            <h3>Pearson Correlation Coefficient &amp; Covariance</h3>
                           <li>Linear regression,Hypothesis testing,Multiple regression</li>
                           <li>Nonlinear regression,Time series analysis,Multivariate analysis</li>
                           <li>Case study of Pearson Correlation Coefficient with examples</li>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="tab07" className="tab-pane fade">
        <div className="topic_covered">
            <h2>Topics Covered</h2>
            <div className="row">
                <div className="col-md-6">
                    <div className="coveredrow">
                        <div className="coveredrow-left"><span>1</span></div>
                        <div className="coveredrow-right">
                            <h3>Machine Learning Introduction</h3>
                            <li>Overview of Machine Learning and its applications</li>
                            <li>Algorithm, Model, Predictor Variable,Response Variable</li>
                            <li>Evaluation Metrics and Techniques</li>
                            <li>Training - Test Split, Steps in Machine Learning</li>
                            <li>Types of Machine Learning (Supervised, Unsupervised, Reinforcement)</li>
                            <li>Data Preprocessing and Feature Engineering</li>
                            <li>Performance Measures (Accuracy, Precision, Recall, F1 Score)</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                        <div className="coveredrow-left"><span>2</span></div>
                        <div className="coveredrow-right">
                            <h3>Regression Analysis and Supervised Learning</h3>
                            <li>Overview Regression Analysis & Supervised Learning</li>
                            <li>Regression models: linear, polynomial, logistic, etc</li>
                            <li>Training, Validation, & Test Sets</li>
                            <li>Evaluation metrics: mean squared error (MSE), R-squared etc</li>
                            <li>Linear Regression & Logistic: A Model-Based Approach</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Stock Price Prediction using Linear regression</li>
                             <li>Spam mail detector for mailbox</li>
                             <li>Predict car price using py-torch & SVC egression</li>
                             <li>Use logistics regression models to predict wine quality</li>
                             <li>Use logistics regression to predict if loan approved</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                        <div className="coveredrow-left"><span>3</span></div>
                        <div className="coveredrow-right">
                            <h3>Supervised Learning - Classification </h3>
                            <li>Understanding Decision Trees and Naive Bayes</li>
                            <li>Linear classifiers</li>
                            <li>Decision Boundaries</li>
                            <li>K-Nearest Neighbours</li>
                            <li>Random Forest</li>
                            <li>Feature selection in Model building</li>
                            <li>Evaluating over fitting via training/test split</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Credit Card Fraud Detection using Classification algorithms</li>
                             <li>Build model and evaluate water quality using random forest</li>
                             <li>Purchase Prediction of Customer using Random Forest</li>
                             <li>Confusion Matrix of Multi Class Classification</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                        <div className="coveredrow-left"><span>4</span></div>
                        <div className="coveredrow-right">
                            <h3>Unsupervised Learning - Clustering</h3>
                            <li>K-Means Clustering</li>
                            <li>Hierarchical Clustering</li>
                            <li>Mean-Shift Algorithm</li>
                            <li>Principal Component Analysis</li>
                            <li>Independent Component Analysis</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Music recommendation in Spotify using k-means clustering </li>
                             <li>Topic Modelling for Twitter Customer Reviews clustering</li>
                             <li>K-Means Clustering model to determine banknote is authentic</li>
                             <li>Dimension reduction using PCA with clustering Model</li>
                             <li>e-Commerce Products Dataset For Record Linkage</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                        <div className="coveredrow-left"><span>5</span></div>
                        <div className="coveredrow-right">
                            <h3>Unsupervised Learning - Association</h3>
                            <li>Association Rule Learning</li>
                            <li>FP-Growth Algorithm</li>
                            <li>Anomaly Detection(Fraud Detection) with Clustering</li>
                            <li>Likeness of Item B Being Purchased after Item A Prediction</li>
                            <li>Frequent Itemsets Evaluation metrics</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Frequent itemset mining using Apriori or FP-growth algorithm  </li>
                             <li>Evaluate the performance of the recommendation System</li>
                             <li>K-Means Clustering model to determine banknote is authentic</li>
                             <li>Dimension reduction using PCA with clustering Model</li>
                             <li>e-Commerce Products Dataset For Record Linkage</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                        <div className="coveredrow-left"><span>6</span></div>
                        <div className="coveredrow-right">
                            <h3>Recommendation System </h3>
                            <li>Recommender Systems Overview</li>
                            <li>Collaborative Filtering</li>
                            <li>Understanding Collaborative Filtering and Support Vector</li>
                            <li>Normalizing Co-Occurrence Matrices and Leveraging</li>
                            <li>The Matrix Completion Task</li>

                        </div>
                         <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Build Job recommendation using collaborative filtering</li>
                             <li>Build a travel recommendation system using datasets</li>
                             <li>Build a Dashion Recommendation System</li>
                             <li>Build a news article recommendation system using datasets</li>
                             <li>Build music playlist recommendation using Support Vector</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                        <div className="coveredrow-left"><span>7</span></div>
                        <div className="coveredrow-right">
                            <h3>Reinforced Learning</h3>
                            <li>Introduction To RL</li>
                            <li>Model-Based Reinforcement Learning</li>
                            <li>Open Al</li>
                            <li>Model Predictive Control (MPC)</li>
                        </div>
                         <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Autonomous Driving System can be trained using reinforced</li>
                             <li>Finance industry to develop trading algorithms</li>
                             <li>Build a Dashion Recommendation System</li>
                             <li>Build a news article recommendation system using datasets</li>
                             <li>Build music playlist recommendation using Support Vector</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                        <div className="coveredrow-left"><span>8</span></div>
                        <div className="coveredrow-right">
                            <h3> Neural Networks</h3>
                           <li>Introduction to Neural Networks</li>
                           <li>Feedforward Neural Networks</li>
                           <li>Convolutional Neural Networks(CNNs)</li>
                           <li>Recurrent Neural Networks(RNNs)</li>
                           <li>Advanced Topics of Neural Networks</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Image Classification using Convolutional Neural Networks</li>
                             <li>Sentiment Analysis using Recurrent Neural Networks</li>
                             <li>Object Detection using Faster R-CNN</li>
                             <li>Music Generation using Generative Adversarial Networks</li>
                             <li>Game Playing using Deep Reinforcement Learning</li>
                             
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div id="tab08" className="tab-pane fade">
        <div className="topic_covered">
            <h2>Topics Covered</h2>
            <div className="row">
                <div className="col-md-6">
                    <div className="coveredrow">
                        <div className="coveredrow-left"><span>1</span></div>
                        <div className="coveredrow-right">
                            <h3>Deep Learning Overview </h3>
                            <li>What is Deep Learning</li>
                            <li>Machine Learning Vs Deep Learning</li>
                            <li>Tensorflow I Keras I Pytorch In details</li>
                            <li>Overview Caffe and Theano</li>
                            <li>Types of file formats in TensorFlow</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                        <div className="coveredrow-left"><span>2</span></div>
                        <div className="coveredrow-right">
                            <h3>TensorFlow Classification Examples</h3>
                            <li>Introduction to TensorFlow</li>
                            <li>Installing TensorFlow</li>
                            <li>Simple Computation, Contents and Variables</li>
                            <li>TensorFlow Classification Examples</li>
                        </div>
                        
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>TensorFlow library to create a text-to-speech-to-text</li>
                             <li>TensorFlow Object Counting API function for tracking vehicle</li>
                             <li>Identifies Different Musical Genres through Sounds</li>
                             <li>Identify customers purchase history,gender,age,interest</li>
                             <li>TensorFlow's Face Recognition Function</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                        <div className="coveredrow-left"><span>3</span></div>
                        <div className="coveredrow-right">
                            <h3>Deep Learning Algorithms </h3>
                            <li>Artificial Neural Networks(ANN)</li>
                            <li>Recurrent Neural Networks(RNN)</li>
                            <li>Convolutional Neural Networks(CNN)</li>
                            <li>Autoencoders and Boltzmann Machine</li>
                        </div>
                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Speech Recognition with Deep Learning</li>
                             <li>Build models with high accuracy Identify Human Face</li>
                             <li>Music Genre Classification using DL</li>
                             <li>Image Classification with CIFAR Dataset</li>
                             <li>ChatBot Learning Human-to-Human Dialogue</li>
                             
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                        <div className="coveredrow-left"><span>4</span></div>
                        <div className="coveredrow-right">
                            <h3>Convolutional Neural Networks (CNN)</h3>
                            <li>Introduction to CNN</li>
                            <li>Convolutional layers</li>
                            <li>Pooling layers</li>
                            <li>Fully Connected Layers</li>
                            <li>Training CNNs</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                        <div className="coveredrow-left"><span>5</span></div>
                        <div className="coveredrow-right">
                            <h3>Recurrent Neural Networks (RNN)</h3>
                            <li>Introduction to RNN</li>
                            <li>Vanishing Gradient Problem</li>
                            <li>Long Short-Term Memory (LSTM) Networks</li>
                            <li>Gated Recurrent Units (GRU)</li>
                            <li>Applications of RNN</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                        <div className="coveredrow-left"><span>6</span></div>
                        <div className="coveredrow-right">
                            <h3>Neural Networks and Deep Learning</h3>
                            <li>Introduction to artificial neural networks (ANN)</li>
                            <li>Backpropagation algorithm</li>
                            <li>Activation functions</li>
                            <li>Loss functions</li>
                            <li>Optimization algorithms</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                        <div className="coveredrow-left"><span>7</span></div>
                        <div className="coveredrow-right">
                            <h3>Generative Adversarial Networks (GANs)</h3>
                            <li>Introduction to GANs</li>
                            <li>Generator and Discriminator Networks</li>
                            <li>Loss functions for GANs</li>
                            <li>Training GANs</li>
                        </div>
                    </div>
                </div>

                 <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                        <div className="coveredrow-left"><span>9</span></div>
                        <div className="coveredrow-right">
                            <h3>Transfer Learning</h3>
                            <li>Introduction to Transfer Learning</li>
                            <li>Pre-trained models</li>
                            <li>Fine-tuning</li>
                            <li>Applications of Transfer Learning</li>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                        <div className="coveredrow-left"><span>8</span></div>
                        <div className="coveredrow-right">
                            <h3>Advanced Deep Learning Concepts</h3>
                            <li>Reinforcement Learning</li>
                            <li>Capsule Networks</li>
                            <li>Attention Mechanisms</li>
                            <li>Self-Organizing Maps (SOM)</li>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="tab09" className="tab-pane fade">
        <div className="topic_covered">
            <h2>Topics Covered</h2>
            <div className="row">
                <div className="col-md-6">
                    <div className="coveredrow">
                        <div className="coveredrow-left"><span>1</span></div>
                        <div className="coveredrow-right">
                            <h3>Introduction to Tableau</h3>
                            <li>Installing Tableau and connecting to data sources</li>
                            <li>Creating dashboard pages</li>
                            <li>How to create calculated columns</li>
                            <li>Data cleaning and reshaping</li>
                            <li>Creating a basic visualization</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                        <div className="coveredrow-left"><span>2</span></div>
                        <div className="coveredrow-right">
                            <h3>Visual Analytics</h3>
                            <li>Getting Started With Visual Analytics</li>
                            <li>Sorting and Grouping</li>
                            <li>Working with sets, set action</li>
                            <li>Filters: Ways to filter, Interactive Filters</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                        <div className="coveredrow-left"><span>3</span></div>
                        <div className="coveredrow-right">
                            <h3>Charts and Graphs</h3>
                            <li>Basic charts and Graph Types</li>
                            <li>Customizing Charts and Formatting</li>
                            <li>Interactive Features and actions</li>
                            <li>Advanced chart types (e.g., maps, treemaps, scatter plots)</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                        <div className="coveredrow-left"><span>4</span></div>


                        <div className="coveredrow-right">
                            <h3>Tableau (Advance)</h3>
                           <li>Mapping</li>
                           <li>Coordinate points</li>
                           <li>Plotting Latitude and Longitude</li>
                           <li>Custom Geocoding</li>
                           <li>Polygon Maps</li>
                           <li>WMS and Background Image</li>
                        </div>

                        <div className="coveredrow-right">
                             <h3>Case Study</h3>
                             <li>Connecting data source and data cleansing </li>
                             <li>Working with various Charts </li>
                             <li>Deployment of Predictive model in visualization</li>
                             
                        </div>

                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                        <div className="coveredrow-left"><span>5</span></div>
                        <div className="coveredrow-right">
                            <h3>Dashboard and Stories</h3>
                            <li>Working in Views with Dashboards and Stories</li>
                            <li>Working with Sheets Fitting Sheets</li>
                            <li>Legends and Quick Filters</li>
                            <li>Tiled and Floating Layouts</li>
                            <li>Floating Objects</li>

                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                        <div className="coveredrow-left"><span>6</span></div>
                        <div className="coveredrow-right">
                            <h3>Advanced Chart Types and Analytics</h3>
                            <li>Creating Advanced Chart types (treemaps, heatmaps, etc.)</li>
                            <li>Using statistical functions and analytics (trend lines, forecasting)</li>
                            <li>Creating sets, groups, and bins for data analysis</li>

                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                        <div className="coveredrow-left"><span>7</span></div>
                        <div className="coveredrow-right">
                            <h3>Getting Started With Power BI</h3>
                            <li>Installing Power BI Desktop</li>
                            <li>Overview of the Workflow in Power BI Desktop</li>
                            <li>Introducing the Different Views of the Data Mode</li>
                            <li>Query Editor Interface</li>
                            <li>Working on Data Model</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                        <div className="coveredrow-left"><span>8</span></div>
                        <div className="coveredrow-right">
                            <h3>Programming with Power BI</h3>
                            <li>Working with Time Series</li>
                            <li>Understanding aggregation and granularity</li>
                            <li>Filters and Slicers in Power BI Maps</li>
                            <li>Scatterplots and BI Reports</li>
                        </div>
                    </div>
                </div>

                 <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                        <div className="coveredrow-left"><span>9</span></div>
                        <div className="coveredrow-right">
                            <h3>Connecting Dataset with Power BI</h3>
                            <li>Creating a Customer</li>
                            <li>Segmentation Dashboard</li>
                            <li>Analyzing the Customer</li>
                            <li>Segmentation Dashboard</li>
                        </div>
                    </div>
                </div>

                 <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                         <div className="coveredrow-left"><span>10</span></div>
                        <div className="coveredrow-right">
                            <h3>Advanced features</h3>
                            <li>Creating calculated columns and measures with DAX</li>
                            <li>Using custom visuals</li>
                            <li>Building hierarchical visualizations with drill-downs</li>
                            <li>Creating and using templates</li>
                            <li>Publishing reports and dashboards to the Power BI Service</li>
                        </div>
                    </div>
                </div>
            
            </div>


            
            </div>

           
            
            </div>


 <div id="tab010" className="tab-pane fade">
        <div className="topic_covered">
            <h2>Topics Covered</h2>
            <div className="row">
                <div className="col-md-6">
                    <div className="coveredrow">
                        <div className="coveredrow-left"><span>1</span></div>
                        <div className="coveredrow-right">
                            <h3>Introduction to NLP</h3>
                            <li>Stop Words, Tokenization</li>
                            <li>Text Analytics Vs NLP</li>
                            <li>Bag of Words Model,Word Vectorizer</li>
                            <li>Introduction to Sequential data</li>
                            <li>Text Preprocessing using NLP</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                        <div className="coveredrow-left"><span>2</span></div>
                        <div className="coveredrow-right">
                            <h3>Language Modeling</h3>
                            <li>N-gram models</li>
                            <li>Smoothing techniques</li>
                            <li>Language Model Evaluation</li>
                            <li>Working with maps and geographic data</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                        <div className="coveredrow-left"><span>3</span></div>
                        <div className="coveredrow-right">
                            <h3>Named Entity Recognition and Relation Extraction</h3>
                            <li>Named entity Recognition</li>
                            <li>Relation Extraction</li>
                            <li>Evaluation Metrics for NER and Relation Extraction</li>
                            <li>Context-free Grammars using NLP</li>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                        <div className="coveredrow-left"><span>4</span></div>


                        <div className="coveredrow-right">
                            <h3>NLP Advanced</h3>
                           <li>RNNs and its Mechanisms</li>
                           <li>Vanishing & Exploding gradients in RNNs</li>
                           <li>NLP libraries: NLTK Text blog</li>
                           <li>LSTMs - Long Short-Term Memory</li>
                           <li>Neural Machine Translation</li>
                           <li>Advanced Language Models: Transformers, BERT, XLNet</li>
                        </div>

                        <div className="coveredrow-right">
                             <h3>Projects</h3>
                             <li>Text summarization using Natural language processing </li>
                             <li>Deeper dive project of Automatic Speech Recognition </li>
                             <li>Newspaper Data Cleaning & Pre-processing using NLP</li>
                             <li>Text Classification using scikit-learn and NLP</li>
                             <li>Hate Speech Detection Model</li>
                             <li>Next Word Prediction Model</li>
                             
                        </div>

                    </div>
                </div>
            
            </div>


            
            </div>

           
            
            </div>

        </div>
      </div>

  </div>

    



<div className="projectsnewbg">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course Projects</h1>
        <h5>Projects will be a part of your Certification in MEAN Stack Full Stack Developers Course Training to consolidate your learning. <br/>
            It will ensure that you have real-world experience in MEAN Stack Full Stack Developers Course Field.</h5>
         <div className="projectsnewbg-practice">
            <ul>
                <li>
                    <img src="assets/images/practice-icon.png" alt="" />
                    <h3>Practice 20+</h3>
                    <p>Essential Tools</p>
                </li>
                <li>
                    <img src="assets/images/designed-icon.png" alt="" />
                    <h3 style={{color: '#2aacf6'}}>Designed by</h3>
                    <p>Industry Experts</p>
                </li>
                <li>
                    <img src="assets/images/get-icon.png" alt="" />
                    <h3 style={{color: '#1fcd71'}}>Get Real-world</h3>
                    <p>Experience</p>
                </li>
            </ul>
         </div>

          <div className="projectsnewbg-bottom">

            <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a className="nav-link active" data-toggle="tab" href="#tab012">Beginner</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab013">Intermediate</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab014">Advance</a>
                </li>
             </ul>
            
               <div className="tab-content">
                <div id="tab012" className="tab-pane active">
                    <div id="products" className="owl-carousel owl-theme">
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Face Detection is an initiative to create a computer vision model that can automatically detect and locate human faces within images or video frames.The goal of this project is to enable machines to recognize and analyze human faces in various contexts, such as security, entertainment, or social media.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Artificial intelligence-powered chatbot that can communicate with humans in a natural language.project involves designing, developing, and deploying a chatbot that can perform specific tasks or answer questions for users. The chatbot can be used for various purposes, such as customer support, sales, marketing, or personal assistance</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Restaurant revenue prediction project is an initiative to create a machine learning model that can forecast the revenue of a restaurant based on various factors such as customer footfall, menu items, prices, and marketing promotions. The goal of this project is to help restaurant owners make data-driven decisions to increase their revenue and profitability.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>climate change impacts project on the global food supply is an initiative to investigate how climate change will affect food production, distribution, and consumption worldwide. The project aims to provide insights into how these impacts may vary by region, crop type, and socio-economic factors, and to identify potential strategies for adaptation and mitigation.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                                <p>Credit card fraud detection using classification algorithms is an initiative to create a machine learning model that can automatically detect fraudulent transactions in credit card transactions. The goal of this project is to enable financial institutions to detect and prevent fraud and protect their customers' financial security.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Water quality project using the random forest algorithm in Data Analytics is an initiative to create a machine learning model that can predict water quality parameters such as pH, dissolved oxygen, biochemical oxygen demand (BOD), and total suspended solids (TSS). Predict water quality using datasets.</p>
                            </div>
                        </div>
                    </div>
                </div>
              
                <div id="tab013" className="tab-pane fade">
                    <div id="products1" className="owl-carousel owl-theme">
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Face Detection</span></h3>
                                <p>Purchase prediction of customer using random forest is a Data Analytics project that aims to predict whether a customer is likely to make a purchase based on their historical purchase behavior and demographic data. The goal of this project is to help businesses understand their customers' purchasing patterns</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>AI Chatbot</span></h3>
                               <p>Predicting house prices using regression is a Data Analytics project that aims to create a machine learning model that can predict the sale price of a house based on various features such as the number of bedrooms, bathrooms, square footage, location, and age of the property</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                               <h3><span>Topic Modelling for Twitter Customer Reviews clustering</span></h3>
                                <p>Topic modeling is a powerful technique in natural language processing that can be used to extract and identify themes or topics in a large corpus of text data. In the context of Twitter customer reviews clustering, topic modeling can be used to identify the main themes or topics that customers are discussing in their reviews</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Authentic vs. Fake Banknote Classification</span></h3>
                                <p>Using supervised learning algorithms such as logistic regression, decision trees, random forests, or support vector machines (SVMs) used to authentic vs. fake banknote classification.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                 <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>Principal Component Analysis (PCA) can help improve the clustering performance by reducing the dimensionality of the data. Dimension reduction using PCA with clustering models is a powerful technique to reduce the dimensionality of the data while improving the clustering performance.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>E-Commerce Products Dataset</span></h3>
                                <p>Record linkage is the process of linking records that refer to the same entity or object across different data sources. In the context of e-commerce products, record linkage can be used to link product records from different e-commerce platforms or retailers that refer to the same product.</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>Anomaly Detection with clustering MEAN Stack Full Stack Developers Course </span></h3>
                                <p>Anomaly detection, particularly for fraud detection, can be achieved using clustering techniques in Data Analytics. The idea is to use clustering to group data points together and identify any outliers or anomalies that do not belong to any cluster.</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Likeness of Item B being purchased after item A prediction</span></h3>
                                <p>Association rules mining is a technique used to find patterns or relationships between items in a dataset. In the context of e-commerce, association rules mining can be used to find items that are frequently purchased together, which can be used to make recommendations to customers.</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div id="tab014" className="tab-pane fade">
                    <div id="products2" className="owl-carousel owl-theme">
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                               <h3><span>Online Movie recommendation system to predict preference </span></h3>
                                <p>Movie Recommendation system is a Data Analytics solution that predicts the preferences of users for movies and recommends relevant movies to them. The system uses machine learning algorithms to analyze user data and movie metadata to make predictions and recommendations.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/alI-chatbot.png" alt="" />
                                <h3><span>Online Books recommendation System</span></h3>
                                <p>Collaborative filtering popular approach to recommendation systems.It involves analyzing the behavior of similar users to predict what a user might like. For example, if User A and User B both read and liked similar books, the system might recommend a new book to User A based on the assumption that they will also like it</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/restaurant-revenue.png" alt="" />
                                <h3><span>Restaurant Revenue Prediction</span></h3>
                                <p>One popular architecture for speech recognition is the recurrent neural network (RNN), which can model the temporal dependencies in speech.Use the preprocessed data to train your neural network.</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="products_slide">
                                <img src="assets/images/face-detection.png" alt="" />
                                <h3><span>Design chatGPT</span></h3>
                                <p>Use ChatGPT deep learning techniques to generate human-like responses to user inputs.ChatGPT uses a variant of the transformer architecture called the Generative Pre-trained Transformer (GPT). This architecture allows the model to process sequences of text and generate new text that is coherent and grammatically correct</p>
                            </div>
                        </div>
                      
                    </div>
                  </div>
              </div>

         </div>

    </div>
</div>


<div className="syllabusnewbg">
    <div className="container">
        <div className="row">
        <div className="col-lg-7">

            <div className="syllabusheadings">
                <h1>
                    <span>MEAN Stack Full Stack Developers Course Course Syllabus</span>
                    <a href=""><i className="fa fa-download" aria-hidden="true"></i>  Download brochure</a>
                </h1>
                <p>Logicmojo provides Live, Interactive Online Sessions guided by Professionals working in top MNCs. All sessions are covered practically with real-time industrial projects and case studies.
                </p>
            </div>

            <div className="faqnew">
                <div className="accordion" id="accordionExample">

                    <div className="card">

                        <div className="card-header" id="heading00">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse00" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 1 Basic to Advanced Python  </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse00" className="collapse" aria-labelledby="heading00" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Python deep-dive ( 3 hrs )</h4>
                                <ul>
                                    <li>Working With Numbers, Booleans and Strings</li>
                                    <li>String types and formatting, String operations</li>
                                    <li>List, Tuples, Dictionaries  Python Lists, Tuples, Dictionaries</li>
                                    <li> Basic Operations Indexing, Slicing, and Matrixes</li>
                                    <li>Built-in Functions & Methods</li>
                                    <li>Exercises on List,Tuples And Dictionary</li>
                                    <li>Functions & Modules</li> 
                                    <li>Exceptional Handling and Regular Expression</li>
                                </ul>
    

                                <h4 className="mt-3">Chapter 2: Library of Python used for ML/AI</h4>
                                <ul>
                                    <li>Numpy, Pandas, Matplotlib, Seaborn, Scipy</li>
                                </ul>
                                <h4 className="mt-3">Chapter 3: Data Analysis Using Numpy</h4>
                                <ul>
                                    <li>Introduction to Numpy</li>
                                    <li>Array Creation, Printing Arrays. Basic Operation</li>
                                    <li>Indexing, Slicing and Iterating, Shape Manipulation</li>
                                    <li>Vector stacking, Broadcasting with Numpy</li>
                                    <li>Numpy for Statistical Operation</li>
                                </ul>
                                <h4 className="mt-3">Chapter 3: Data Analysis Using Pandas</h4>
                                <ul>
                                    <li>Introduction to Pandas</li>
                                    <li>Pandas Data Frames, Indexing Data Frames</li>
                                    <li>Basic Operations With Data frame</li>
                                    <li>Sub setting and filtering a data frame</li>
                                </ul>
                                <h4 className="mt-3">Chapter 4: Data Visualization using Matplotlib</h4>
                                <ul>
                                    <li>How to use & configure Matplotlib</li>
                                    <li>plot(), Controlling Line Properties</li>
                                    <li>Subplot with Functional Method, Multiple Plot</li>
                                    <li>Working with Multiple Figures</li>
                                    <li>Histograms</li>
                                </ul>
                                <h4 className="mt-3">Chapter 4: Data Visualization using Seaborn</h4>
                                <ul>
                                    <li>Intro to Seaborn, Visualizing statistical relationships</li>
                                    <li>Plotting with categorical data</li>
                                    <li>Visualizing linear relationships</li>
                                    <li>Seaborn Exercise</li>
                                    
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Resume Screening project with Python Library</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading001">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse001" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 2 - Applied Statistics in Machine Learning  </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse001" className="collapse" aria-labelledby="heading001" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Fundamentals of Math and Probability ( 3 hrs )</h4>
                                <ul>
                                    <li>Variables, Random Variables</li>
                                    <li>Population, Sample, Mean, Population Distribution</li>
                                    <li>Sample Distribution, Mean, Median, Mode</li>
                                    <li>Range, Measure of Dispersion, Variance</li>
                                    <li>Probability Density function</li>
                                </ul>

                                <h4 className="mt-3">Chapter 2: Statistics, Statistical Thinking</h4>
                                <ul>
                                    <li>Standard Normal Distribution, Z Score </li>
                                    <li>Standard Deviation, Gaussian Distribution</li>
                                    <li>Cumulative  Distribution function</li>
                                    <li>Hypothesis Testing & Plotting graph</li>
                                    <li>Central limit theorem, Covariance</li>
                                    <li>Pearson Correlation Coefficient</li>
                                    <li>Spearman Rank Coefficient, Hypothesis Testing</li>
                                </ul>
                                <h4 className="mt-3">Chapter 3: Advanced Statistics</h4>
                                <ul>
                                    <li>Q-Q plot,Skewness of Data </li>
                                    <li>Discrete & continuous distribution</li>
                                    <li>Bernoulli & binomial distribution</li>
                                    <li>Log normal distribution </li>
                                    <li>Pox cox transformation</li>
                                    <li>Poisson distribution</li>
                                    <li>Application of Non Gaussian distribution</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast </p>
                                <p>2. Climate Change Impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading002">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse002" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 3 - Machine Learning </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse002" className="collapse" aria-labelledby="heading002" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Machine Learning Introduction  ( 3 hrs )</h4>
                                <ul>
                                    <li>Machine learning elements </li>
                                    <li>Algorithm, Model, Predictor Variable, Response Variable</li>
                                </ul>

                                <h4>Chapter 2: Regression Supervised Learning( 3 hrs )</h4>
                                <ul>
                                    <li>Linear Regression</li>
                                    <li>Support vector machine(SVC)</li>
                                    <li>Ridge Regression</li>
                                    <li>Logistics Regression</li>
                                    <li>Lasso Regression</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Stock Price Prediction using Linear regression</p>
                                <p>2. Spam mail detector for mailbox</p>
                                <p>3. Predict car price using py-torch & SVC egression</p>
                                <p>4. Use logistics regression models to predict wine quality</p>
                                <p>5. Use logistics regression to predict if loan approved or not</p>

                                <h4 className="mt-3">Chapter 3: Supervised Learning - Classification </h4>
                                <ul>
                                    <li>Understanding Decision Trees and Naive Bayes</li>
                                    <li>Linear classifiers</li>
                                    <li>Decision boundaries</li>
                                    <li>K-Nearest Neighbours</li>
                                    <li>Random forest</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Credit Card Fraud Detection using Classification algorithms </p>
                                <p>2. Build model and evaluate water quality using random forest</p>
                                <p>3. Purchase prediction of customer using random forest</p>
                                <p>4. Confusion Matrix of Multi Class Classification</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading003">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse003" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 3 - Advance Machine Learning </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse003" className="collapse" aria-labelledby="heading003" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Unsupervised Learning Clustering ( 3 hrs )</h4>
                                <ul>
                                    <li>K-Means Clustering</li>
                                    <li>Hierarchical Clustering</li>
                                    <li>Mean-shift algorithm</li>
                                    <li>Principal Component Analysis</li>
                                    <li>Independent Component Analysis</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Music recommendation in Spotify using k-means clustering </p>
                                <p>2. Topic Modelling for Twitter Customer Reviews clustering </p>
                                <p>3. K-Means Clustering model to determine banknote is authentic </p>
                                <p>3. Dimension reduction using PCA with clustering Model </p>
                                <p>3. e-Commerce Products Dataset For Record Linkage </p>

                                <h4 className="mt-3">Chapter 2: Unsupervised Learning Association</h4>
                                <ul>
                                    <li>Introduction to unsupervised learning</li>
                                    <li>Clustering: Distance metrics, K-means, hierarchical clustering</li>
                                    <li>Types of Analysis - Descriptive, Predictive, and Prescriptive</li>
                                    <li>Bias Variance Tradeoff - Overfitting vs Underfitting</li>
                                    <li>Clustering validation & Generative models</li>
                                    <li>Dimensionality Reduction: Principal Component Analysis (PCA)</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Anomaly detection(fraud detection) with clustering</p>
                                <p>2. Likeness of Item B being purchased after item A prediction</p>
                                <p>3. Fraud Detection in Financial Transactions</p>
                                <p>4. Document Clustering in Natural Language Processing</p>

                                 <h4 className="mt-3">Chapter 3: Recommendation System </h4>
                                <ul>
                                    <li>Recommender systems overview</li>
                                    <li>Collaborative filtering</li>
                                    <li>Understanding Collaborative Filtering and Support Vector Machine</li>
                                    <li>Normalizing co-occurrence matrices and leveraging purchase histories</li>
                                    <li>The matrix completion task</li>
                                    <li>Recommender systems ML block diagram</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Online Movie recommendation system to predict preference</p>
                                <p>2. Online Books recommendation System</p>
                                <p>3. e-commerce product recommendation like Amazon</p>

                                <h4 className="mt-3">Chapter 4: Reinforced Learning </h4>
                                <ul>
                                    <li>Introduction To RL</li>
                                    <li>RL Techniques and Methods</li>
                                    <li>Value-Based Methods(Q-Learning,SARSA,Deep Q-Networks)</li>
                                    <li>Policy-Based Methods(Policy Gradient, REINFORCE, Actor-Critic Methods)</li>
                                    <li>Exploration and Exploitation</li>
                                    
                                </ul>
                                <h5>Ensemble Techniques:</h5>
                                <p>Boosting | Gradient</p>
                                <p>Boosting | XGBoost</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading004">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse004" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 4 - Deep Learning </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse004" className="collapse" aria-labelledby="heading004" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Deep Learning Overview  ( 3 hrs )</h4>
                                <ul>
                                    <li>What is Deep Learning?</li>
                                    <li>Machine Learning Vs Deep Learning</li>
                                    <li>Tensorflow I Keras I Pytorch In details</li>
                                    <li>Overview Caffe and Theano</li>
                                    <li>Types of file formats in TensorFlow</li>
                                </ul>

                                <h4 className="mt-3">Chapter 2: TensorFlow Classification Examples</h4>
                                <ul>
                                    <li>Introduction to TensorFlow</li>
                                    <li>Installing TensorFlow</li>
                                    <li>Simple Computation, Contents and Variables</li>
                                    <li>Types of file formats in TensorFlow</li>
                                    <li>TensorFlow Classification Examples</li>
                                </ul>

                                <h4 className="mt-3">Chapter 3: Deep Learning Algorithms </h4>
                                <ul>
                                    <li>Artificial Neural Networks(ANN)</li>
                                    <li>Recurrent Neural Networks(RNN)</li>
                                    <li>Convolutional Neural Networks(CNN)</li>
                                    <li>Autoencoders and Boltzmann Machine</li>
                                    <li>Generative Adversarial Networks (GANs)</li>
                                    <li>Restricted Boltzmann Machines (RBMs)</li>

                                </ul>

                                <h5>Project:</h5>
                                <p>1. Speech Recognition with Deep Learning</p>
                                <p>2. Build models with high accuracy Identify Human Face</p>
                                <p>3. Music Genre Classification using DL</p>
                                <p>4. Image Classification with CIFAR Dataset</p>
                                <p>5. ChatBot Learning Human-to-Human Dialogue</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading005">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse005" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 5 - Natural Language Processing </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse005" className="collapse" aria-labelledby="heading005" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Introduction to NLP  ( 3 hrs )</h4>
                                <ul>
                                    <li>Introduction to NLP</li>
                                    <li>Stop Words, Tokenization</li>
                                    <li>Text Analytics Vs NLP</li>
                                    <li>Bag of Words Model, Word Vectorizer</li>
                                    <li>Types of file formats in TensorFlow</li>
                                    <li>Introduction to Sequential data</li>
                                </ul>

                                <h4 className="mt-3">Chapter 2: NLP Advanced </h4>
                                <ul>
                                    <li>RNNs and its Mechanisms</li>
                                    <li>Vanishing & Exploding gradients in RNNs</li>
                                    <li>NLP libraries: NLTK Text blog</li>
                                    <li>LSTMs - Long short-term memory</li>
                                    <li>Neural Machine Translation</li>
                                    <li>Advanced Language Models: Transformers, BERT, XLNet</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Text summarization using Natural language processing </p>
                                <p>2. Deeper dive project of Automatic Speech Recognition </p>
                                <p>3. Newspaper Data Cleaning & Pre-processing using NLP</p>
                                <p>4. Text Classification using scikit-learn and NLP</p>
                                <p>5. Hate Speech Detection Model</p>
                                <p>6. Next Word Prediction Model</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading006">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse006" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 6- Tableau</button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse006" className="collapse" aria-labelledby="heading006" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Introduction to Tableau ( 3 hrs )</h4>
                                <ul>
                                    <li>Installing Tableau and connecting to data sources</li>
                                    <li>Creating dashboard pages</li>
                                    <li>How to create calculated columns</li>
                                    <li>Data cleaning and reshaping</li>
                                    <li>Creating a basic visualization</li>
                                </ul>

                                <h4 className="mt-3">Chapter 2: Charts and Graphs</h4>
                                <ul>
                                    <li>Basic charts and Graph Types</li>
                                    <li>Customizing Charts and Formatting</li>
                                    <li>Interactive Features and actions</li>
                                    <li>Advanced chart types (e.g., maps, treemaps, scatter plots)</li>
                                </ul>

                                <h4 className="mt-3">Chapter 3: Tableau (Advance)</h4>
                                <ul>
                                    <li>Mapping</li>
                                    <li>Coordinate points</li>
                                    <li>Plotting Latitude and Longitude</li>
                                    <li>Custom Geocoding</li>
                                    <li>Polygon Maps</li>
                                    <li>WMS and Background Image</li>
                                </ul>

                                <h5>Case Study:</h5>
                                <p>1. Connecting data source and data cleansing</p>
                                <p>2. Working with various Charts</p>
                                <p>3. Deployment of Predictive model in visualization</p>

                                <h4 className="mt-3">Chapter 4: Dashboard and Stories</h4>
                                <ul>
                                    <li>Working in Views with Dashboards and Stories</li>
                                    <li>Working with Sheets Fitting Sheets</li>
                                    <li>Legends and Quick Filters</li>
                                    <li>Tiled and Floating Layouts</li>
                                    <li>Floating Objects</li>
                                </ul>

                                <h4 className="mt-3">Chapter 5: Advanced Chart Types and Analytics</h4>
                                <ul>
                                    <li>Creating Advanced Chart types (treemaps, heatmaps)</li>
                                    <li>Working with Sheets Fitting Sheets</li>
                                    <li>Using statistical functions and analytics(trend lines, forecasting)</li>
                                    <li>Creating sets, groups, and bins for data analysis</li>
                                </ul>
                                 <h5>Projects:</h5>
                                <p>1. Patient Risk Healthcare Dashboard</p>
                                <p>2. Sales Forecast Analysis Dashboard</p>
                                <p>3. Product Availability Dashboard</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>
                    <div className="card">

                        <div className="card-header" id="heading007">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse007" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 7- Power BI </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse007" className="collapse" aria-labelledby="heading007" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Getting Started With Power BI ( 3 hrs )</h4>
                                <ul>
                                    <li>Installing Power BI Desktop</li>
                                    <li>Overview of the Workflow in Power BI Desktop</li>
                                    <li>Introducing the Different Views of the Data Mode</li>
                                    <li>Query Editor Interface</li>
                                    <li>Working on Data Model</li>
                                </ul>

                                <h4 className="mt-3">Chapter 2: Programming with Power BI</h4>
                                <ul>
                                    <li>Working with Time Series</li>
                                    <li>Understanding aggregation and granularity</li>
                                    <li>Filters and Slicers in Power BI Maps</li>
                                    <li>Scatterplots and BI Reports</li>
                                </ul>

                                <h4 className="mt-3">Chapter 3: Connecting Dataset with Power BI</h4>
                                <ul>
                                    <li>Creating a Customer</li>
                                    <li>Segmentation Dashboard</li>
                                    <li>Analyzing the Customer</li>
                                    <li>Segmentation Dashboard</li>
                                </ul>

                                 <h4 className="mt-3">Chapter 4: Advanced features Power BI</h4>
                                <ul>
                                    <li>Creating calculated columns and measures with DAX</li>
                                    <li>Using custom visuals</li>
                                    <li>Building hierarchical visualizations with drill-downs</li>
                                    <li>Creating and using templates</li>
                                    <li>Publishing reports and dashboards to the Power BI Service</li>
                                </ul>

                                <h5>Project:</h5>
                                <p>1. Financial Performance Analysis</p>
                                <p>2. Anomaly Detection in Credit Card Transactions </p>
                                <p>3. AutoML Cashflow Optimization for Insurance Company </p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>

                    <div className="card">

                        <div className="card-header" id="heading008">
                  
                          <h2 className="mb-0">
                  
                            <button type="button" className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse008" aria-expanded="false"><i className="fa fa-angle-down"></i> Module 8 - Computer Vision </button>
                  
                          </h2>
                  
                        </div>
                  
                        <div id="collapse008" className="collapse" aria-labelledby="heading008" data-parent="#accordionExample">
                  
                          <div className="card-body">
                  
                            <div className="moduleintro">
                                <h4>Chapter 1: Introduction to Computer Vision ( 3 hrs )</h4>
                                <ul>
                                    <li>Human and Machine Vision</li>
                                    <li>Applications of Computer Vision</li>
                                </ul>
                                <h5>Project:</h5>
                                <p>1. Statical Analysis of Health Insurance Pricing Forecast</p>
                                <p>2. Climate Change impacts on the Global Food Supply</p>
                                <p>3. Statistical analysis of road accident in India</p>

                                <h4 className="mt-3">Chapter 2: Image Formation and Representation</h4>
                                <ul>
                                    <li>Image Formation Model</li>
                                    <li>Digital Images and Color Spaces</li>
                                    <li>Image Enhancement and Filtering</li>
                                    
                                </ul>

                                  <h4 className="mt-3">Chapter 3: Image Features and Feature Detection</h4>
                                <ul>
                                    <li>Edge Detection and Feature Detection</li>
                                    <li>Scale-Space Theory and Laplacian of Gaussian (LoG)</li>
                                    <li>Scale-Space Theory and Laplacian of Gaussian (LoG)</li>
                                    
                                </ul>

                                 <h4 className="mt-3">Chapter 4: Image Segmentation</h4>
                                <ul>
                                    <li>Thresholding and Region Growing</li>
                                    <li>Edge-based and Boundary-based Segmentation</li>
                                    <li>Watershed Segmentation and Mean Shift Segmentation</li>
                                    
                                </ul>

                                <h4 className="mt-3">Chapter 5: Object Recognition and Classification</h4>
                                <ul>
                                    <li>Template Matching and Correlation</li>
                                    <li>Object Recognition using Features</li>
                                    <li>Machine Learning Approaches to Object Recognition and Classification</li>
                                    
                                </ul>

                                <h4 className="mt-3">Chapter 6: Deep Learning for Computer Vision</h4>
                                <ul>
                                    <li>Convolutional Neural Networks (CNNs)</li>
                                    <li>Object Detection and Localization</li>
                                    <li>Image Segmentation using CNNs</li>
                                    
                                </ul>

                                <h4 className="mt-3">Chapter 7: Advanced Topics in Computer Vision</h4>
                                <ul>
                                    <li>Video Analysis and Tracking</li>
                                    <li>Object Tracking and Localization</li>
                                    <li>Medical Image Analysis and Applications</li>
                                    
                                </ul>


                                <h5>Project:</h5>
                                <p>1. AI based face detection system </p>
                                <p>2. Human emotion detection system </p>
                                <p>3. Handwritten Digit Recognition</p>
                                <p>4. Computer vision system that can detect and locate objects in an image</p>

                            </div>
                  
                          </div>
                  
                        </div>
                  
                    </div>


                </div>
            </div>
        </div>
        <div className="col-lg-5">
            <div className="programmright">

                <h1>Program highlights</h1>
            
                <div className="programlist">
            
                    <ul>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">110+ Hours Live sessions</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">3+ Projects</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">1:1 Doubt Session</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">1 Year Subscription </div>
            
                            </div>
            
                        </li>
            
                    </ul>
            
                    <ul>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">Life time accessibility</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">Job Assistance Program</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">Peer to peer Learning</div>
            
                            </div>
            
                        </li>
            
                        <li>
            
                            <div className="proginfoss">
            
                                <div className="priiconss"><img src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg" alt="" border="0" /></div>
            
                                <div className="protxts">Mock Interview </div>
            
                            </div>
            
                        </li>
            
                    </ul>
            
                </div>




                <p style={{float: 'left', width: '100%'}}>
                <a href="" className="applnowbtn mt-4">Talk to our experts <i className="fa fa-angle-right arrowclass" aria-hidden="true"></i></a>
                </p>

            </div>
        </div>
    </div>
</div>
</div>



<div className="careerservices-new">
    <div className="container">
        <h1>Career Services By Logicmojo</h1>
        <div className="careerservices-new-left"><img src="assets/images/career-services.png" alt="" /></div>
        <div className="careerservices-new-right">
            <div className="projectsnewbg-bottom">
                <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                      <a className="nav-link active" data-toggle="tab" href="#tab020">Job Assistance</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-toggle="tab" href="#tab021">Interview Preparation</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-toggle="tab" href="#tab022">Profile Building</a>
                    </li>
                 </ul>
                 <div className="tab-content">
                    <div id="tab020" className="tab-pane active">
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Job Assistance starts After Course Completion</h2>
                                <p>Job referrals start after the completion of a course, with career services professionals offering guidance and support to students as they prepare to enter MEAN Stack Full Stack Developers Course & AI domain.</p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Job Assistance Criteria</h2>
                                <p>Job Assistance program for our candidates being regular with classes. Get noticed & referred by our 150+ hiring partners for the profile of Data Scientist, Machine Learning Engineer, Data Analytics, MLOps as well as Business Analytics.</p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                    <div id="tab021" className="tab-pane">
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Learn MEAN Stack Full Stack Developers Course, AI & ML with Case Studies & Projects</h2>
                                <p>Learn Full Stack AI & Data Scienece topics with 30+ real projects with datasets. Designed & Implement Models, Deploy in the Prod Environment. Make your profile storng in MEAN Stack Full Stack Developers Course & AI Field </p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Mock Interviews & Mentorship 1 to 1 Sessions</h2>
                                <p>Attend 1 to 1 Classes with the mentor during mentorship program. Make your progress in the right direction under guidance of mentor having 5+ years experience in DS, AI & ML Domain. Check your progress with mock interviews 1 to 1 Online Session , experience the actual interview environment.</p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                    <div id="tab022" className="tab-pane">
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/placement-assistance.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Resume Preparation </h2>
                                <p>After completion of the course , we need to prepare candidate resume before applying for IT Data Scientist as well as Data analytics profile" rephrase. Attend 1 to 1 session with mentor for resume preparation discussion.</p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 100% of the course completion</a>
                            </div>
                        </div>
                        <div className="placement-assistance">
                            <div className="placement-assistance-left"><img src="assets/images/exclusive-access.png" alt="" /></div>
                            <div className="placement-assistance-right">
                                <h2>Linkedin Profile Update</h2>
                                <p>For every candidate profile will be updated in Linkedin Portal. Linked is considered to be the major Hub for hiring Data Scientist as well as ML engineer.</p>
                                <a href=""><i className="fa fa-calendar-o" aria-hidden="true"></i> After 80% of the course completion</a>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>


<div className="network-reach-newbg">
    <div className="container">
        <h1>The Network Reach of Our Bay</h1>
        <div className="row">
            <div className="col-lg-5">
                <div className="keyfeaturenew">
                    <h2>Our Key Features</h2>
                    <ul>
                        <li>We help you build a strong profile and prepare for MNC interviews.</li>
                        <li>Hassle-free and tailored training for MAANG company interviews.</li>
                        <li>Even after a career break, securing a dream job is achievable.</li>
                        <li>A successful career transition even with 0 coding experience.</li>
                    </ul>
                    <a href="" className="downreportbtn">Download Placement Report <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                </div>
            </div>
            <div className="col-lg-7">
                <div className="keyfeaturenew-logo">
                    <a href=""><img src="assets/images/featurelogo1.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo2.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo3.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo4.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo5.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo1.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo2.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo3.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo4.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo5.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo1.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo2.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo3.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo4.png" alt="" /></a>
                    <a href=""><img src="assets/images/featurelogo5.png" alt="" /></a>
                </div>
            </div>
        </div>
    </div>
</div>


<div className="certificate-companies">
    <div className="container">
        <div className="certificate-companies-img"><img src="assets/images/certificate-companies.png" alt="" /></div>
        <div className="certificate-companies-text">
            <h5>MEAN Stack Full Stack Developers Course Certification</h5>
            <h1>Obtain a certificate directly from companies specializing in AI.</h1>
            <p>Get a chance to work directly with companies as a part of the course on their live Analytics projects. Hence after completing the project successfully you will have experience letter as Data Analyst before you start attending interviews though us.</p>
            <a href="">Download Brochure <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a>
        </div>
    </div>
</div>

<div className="howtoapply-new">
    <div className="container">
        <h1>How to Register For Logicmojo MEAN Stack Full Stack Developers Course Course</h1>
        <div className="row">

            <div className="col-lg-8">
                <div className="howtoapply-new-left">
                    <ul>
                        <li>
                            <h4>Step 1</h4>
                            <h3>Submit Application</h3>
                            <p>Tell us a bit about yourself and why you want todo this program</p>
                        </li>
                        <li>
                            <h4>Step 2</h4>
                            <h3>Application Review</h3>
                            <p>An admission penel will shortlist candidates based on their application</p>
                        </li>
                        <li>
                            <h4>Step 3</h4>
                            <h3>Admission</h3>
                            <p>Selected candidates can begin the PGP AI MI, online within 1-2 weeks</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="col-lg-4">
                <div className="howtoapply-new-right">
                    <h2>Apply Now</h2>
                    <div className="howtoapply-new-rightform">
                        <form>
        
                            <div className="row"> 
                            
                                  <div className="form-group col-lg-12">
                                    <input type="text" className="form-control" placeholder="Name" />
                                  </div>
    
                                  <div className="form-group col-lg-12">
                                    <input type="text" className="form-control" placeholder="Email address" />
                                  </div>
    
                                  <div className="form-group col-lg-12">
                                    <input type="text" className="form-control" placeholder="Phone number" />
                                  </div>
                      
                                  <div className="form-group col-lg-12">
                                    <select name="" id="" className="form-control">
                                        <option value="">Total work experience*</option>
                                    </select>
                                  </div>

                                  <div className="form-group col-lg-12 privacytext">
                                    By providing your contact details, you agree to our <a href="">Privacy Policy</a>
                                  </div>
    
                                  <div className="form-group col-lg-12">
                                    <input type="submit" className="submitbtn" value="Submit" />
                                  </div>
                      
                      
                                </div>
                            
                                </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<div className="programfeenew">
    <div className="container">
        <h1>MEAN Stack Full Stack Developers Course Course Fee</h1>
        <div className="programfeenew-inner">
            <div className="programfeenew-inner-left">
                <div className="programfeenew-inner-price">
                    <p>Total Fee</p>
                    <h2>₹ 72,199</h2>
                </div>
            </div>
            <div className="programfeenew-inner-right">
                <h5>No Cost EMI</h5>
                <div className="d-flex align-items-center justify-content-between">
                    <h4><span>As low as</span> ₹ 6,000/month</h4>
                    <a href="">Apply now</a>
                </div>
                <p>We have partnered with the following financing companies to provide competitive finance options at 0% interest rate with no hidden costs...</p>
                <ul>
                    <li><img src="assets/images/feelogo1.png" alt="" /></li>
                    <li><img src="assets/images/feelogo2.png" alt="" /></li>
                    <li><img src="assets/images/feelogo3.png" alt="" /></li>
                    <li><img src="assets/images/feelogo4.png" alt="" /></li>
                    <li><img src="assets/images/feelogo5.png" alt="" /></li>
                </ul>
            </div>
        </div>
    </div>
</div>


<div className="eligibility-criteria-row">
    <div className="container">

        <div className="row">

        <div className="col-md-6">
            <div className="eligibility-criteria">
                <h2>MEAN Stack Full Stack Developers Course Course Eligibility Criteria</h2>
                <ul className="eligibilitylist1">
                    <li><span><img src="assets/images/eligibilitylist1-icon1.png" alt="" /></span> A bechelor's degree with an average of 50% or higher marks</li>
                    <li><span><img src="assets/images/eligibilitylist1-icon2.png" alt="" /></span> Basic understanding of programming concepts and mathematics</li>
                    <li><span><img src="assets/images/eligibilitylist1-icon3.png" alt="" /></span> 2+ years of work experience preferred</li>
                </ul>
            </div>
        </div>

        <div className="col-md-6">
            <div className="eligibility-criteria">
                <h2>Who can apply for the MEAN Stack Full Stack Developers Course course?</h2>
                <ul className="eligibilitylist2">
                    <li>Software engineers</li>
                    <li>IT Professionals</li>
                    <li>Data Professionals</li>
                    <li>Business Analysis</li>
                    <li>Product Managers</li>
                 </ul>
            </div>
        </div>

    </div>
</div>
</div>














<div className="supportbgnew">
    <div className="container">
        <h1>24/7 Learner’s Support</h1>
        <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img"><img src="assets/images/supportimg.png" alt="" /></div>
            <div className="supportbgnew-inner-content">
                <h4>Got more questions?</h4>
                <h2>Talk to our team directly</h2>
                <p>Reach us and a learning consultant will get in touch with you shortly</p>
                <a href=""><i className="fa fa-whatsapp"></i> Enquire now</a>
                <a href="" style={{background: '#1a64c0'}}><i className="fa fa-whatsapp"></i> +91 80889-75867</a>
            </div>
        </div>
    </div>
</div>  





            
        </div>

    )
}

export default MEAN_Stack_Full_Stack_Developers_Course